import { computed, type ComputedRef } from 'vue'

import {
  BaseballEventDetailId,
  BaseballEventDetailIdHalfValues,
} from '@collector/sportsapi-client-legacy'
import { useEventDetails } from '@desktop/views/Relation/composables'

export function useEventDetailHalf(): {
  eventDetailHalfValue: ComputedRef<BaseballEventDetailIdHalfValues>
} {
  const { getEventDetailValue } = useEventDetails()

  const eventDetailHalfValue = computed(
    () =>
      getEventDetailValue(
        BaseballEventDetailId.Half,
      ) as BaseballEventDetailIdHalfValues,
  )

  return {
    eventDetailHalfValue,
  }
}
